import Logger from "./logger";
const logger = Logger("call");
interface CallResponse {
  response: {[key: string]: any},
  status: string | number
}
const call = (api: string, path: string, method: string, data = {}, token: string | null = null): Promise<CallResponse> => {
  const headers: {[key: string]: string} = {
    Accept: "application/json",
    "Content-Type": "application/json",
  };
  if (token) {
    headers.Authorization = `Bearer ${token}`;
  }
  const body = {
    method,
    ...data,
  };

  logger.debug("calling api %s - %s data %s", path, method, data);

  return new Promise((resolve, reject) => {
    fetch(`${api}/${path}`, {
      method: "post",
      headers: headers,
      body: JSON.stringify(body),
    })
      .then(async (res) => ({
        response: await res.json(),
        status: res.status,
      }))
      .then(({ response, status }) => {
        logger.debug("api response", response);
        resolve({ response, status });
      })
      .catch((err) => {
        logger.error("api error", err);
        reject(err);
      });
  });
};
export default call;
